import FileSubmissionForm from "./FileSubmissionForm/FileSubmissionForm";
import KodeEtik from "./KodeEtik";

export default function MKSpesialPengumpulanBerkas({ mKSpesial, deadlines }) {
  return (
    <div className="mt-4 text-sm">
      <div className="flex flex-row gap-8">
        <div className="flex-1 text-sm">
          <FileSubmissionForm mKSpesial={mKSpesial} deadlines={deadlines} />
        </div>
        <div className="flex-1 text-sm">
          <KodeEtik mKSpesial={mKSpesial} />
        </div>
      </div>
    </div>
  );
}
